<div class="two-factor-dialog">
  <h3 class="title">{{ handleModalTitle() | translate }}</h3>
  <span class="description" [class.qr-subtitle]="currentStep === modalSteps.QR_CODE_SECTION">{{
    handleModalDescription() | translate
  }}</span>
  @if (currentStep === modalSteps.SELECT_SECTION) {
    <div class="select-buttons">
      <button
        class="select-button"
        (click)="chosenOtpType === otpTypes.EMAIL ? onSelectButtonDelete() : onSelectButtonClick(otpTypes.EMAIL)"
        [class.active]="chosenOtpType === otpTypes.EMAIL"
      >
        <div class="icon-section">
          <img src="assets/svg/two-factor/email.svg" />
        </div>
        <div class="tetx-section">
          <span class="select-button-title">{{ "TWO_FACTOR_MODAL.SELECT_OTP_VIEW.EMAIL_OTP" | translate }}</span>
          <span class="select-button-description">{{
            "TWO_FACTOR_MODAL.SELECT_OTP_VIEW.EMAIL_OTP_DESCRIPTION" | translate
          }}</span>
        </div>
      </button>
      <button
        class="select-button"
        (click)="chosenOtpType === otpTypes.DEVICE ? onSelectButtonDelete() : onSelectButtonClick(otpTypes.DEVICE)"
        [class.active]="chosenOtpType === otpTypes.DEVICE"
      >
        <div class="icon-section">
          <img src="assets/svg/two-factor/device.svg" />
        </div>
        <div class="tetx-section">
          <span class="select-button-title">{{ "TWO_FACTOR_MODAL.SELECT_OTP_VIEW.DEVICE_OTP" | translate }}</span>
          <span class="select-button-description">{{
            "TWO_FACTOR_MODAL.SELECT_OTP_VIEW.DEVICE_OTP_DESCRIPTION" | translate
          }}</span>
        </div>
      </button>
    </div>
  }
  @if (currentStep === modalSteps.QR_CODE_SECTION) {
    <span class="qr-code-desc">{{ "TWO_FACTOR_MODAL.QR_VIEW.QR_DESCRIPTION" | translate }}</span>
    <img [src]="'data:image/png;base64,' + deviceOtpData.qr_code" alt="QR Code" class="otp-qr-code" />
    <span class="qr-code-text">{{ "TWO_FACTOR_MODAL.QR_VIEW.COPY_CODE_TEXT" | translate }}</span>
    <span class="otp-secret-key">{{ deviceOtpData.otp_secret || "" }}</span>
    <button class="copy-button" [class.is-copied]="isCodeCopied" (click)="copyToClipboard()">
      {{ (isCodeCopied ? "TWO_FACTOR_MODAL.QR_VIEW.CODE_COPIED" : "TWO_FACTOR_MODAL.QR_VIEW.COPY_CODE") | translate }}
    </button>
  }
  @if (currentStep === modalSteps.PASTE_CODE_SECTION) {
    <div class="input-section">
      <app-form-input
        [errors]="errors"
        [shouldRenderErrors]="true"
        [placeholder]="''"
        (modelChange)="handleAuthCodeValue($event)"
        [model]="authCode"
      >
      </app-form-input>
      @if (chosenOtpType === otpTypes.EMAIL) {
        <button
          class="copy-button resend-button"
          [class.is-sended]="isEmailCodeSend && !authCode"
          (click)="handleResendToFactoreCode()"
        >
          {{
            (isEmailCodeSend ? "TWO_FACTOR_MODAL.AUTH_VIEW.CODE_SENDED" : "TWO_FACTOR_MODAL.AUTH_VIEW.SEND_CODE_AGAIN")
              | translate
          }}
        </button>
      }
    </div>
  }
  @if (currentStep === modalSteps.STATIC_TOKENS) {
    <ul>
      @for (token of staticTokens; track token) {
        <li class="token">{{ token }}</li>
      }
    </ul>
    <button
      class="copy-button download-button"
      [class.is-sended]="isEmailCodeSend && !authCode"
      (click)="downloadStaticTokens()"
    >
      {{ "TWO_FACTOR_MODAL.STATIC_TOKENS.DOWNLOAD_CODES" | translate }}
    </button>
  }
  <div
    class="button-section"
    [class.singular]="
      (currentStep === modalSteps.SELECT_SECTION && data.force_otp) || currentStep === modalSteps.STATIC_TOKENS
    "
  >
    @if (currentStep === modalSteps.SELECT_SECTION && !data.force_otp) {
      <app-button-fill-primary
        [class]="'change-button'"
        (clickEmitter)="handleSkipButton()"
        [extraClasses]="'btn--skip'"
      >
        {{ "COMMON.SKIP" | translate }}
      </app-button-fill-primary>
    }
    @if (currentStep !== modalSteps.SELECT_SECTION && currentStep !== modalSteps.STATIC_TOKENS) {
      <app-button-fill-primary
        [class]="'change-button'"
        (clickEmitter)="goToPreviousStep()"
        [extraClasses]="'btn--skip'"
      >
        {{ "COMMON.BACK" | translate }}
      </app-button-fill-primary>
    }
    @if (currentStep !== modalSteps.PASTE_CODE_SECTION && currentStep !== modalSteps.STATIC_TOKENS) {
      <app-button-fill-primary
        [class]="'change-button'"
        (clickEmitter)="goToNextStep()"
        [isDisabled]="!chosenOtpType || chosenOtpType === data.chosen_otp"
      >
        {{ "COMMON.PROCEED" | translate }}
      </app-button-fill-primary>
    }
    @if (currentStep === modalSteps.PASTE_CODE_SECTION) {
      <app-button-fill-primary
        [class]="'change-button'"
        (clickEmitter)="handleVerifySetUpTwoFactorAuthentication()"
        [isDisabled]="!authCode"
        [isLoading]="isVerifying"
      >
        {{ "COMMON.CONFIRM" | translate }}
      </app-button-fill-primary>
    }
    @if (currentStep === modalSteps.STATIC_TOKENS) {
      <app-button-fill-primary [class]="'change-button'" (clickEmitter)="goToApp()">
        {{ "TWO_FACTOR_MODAL.STATIC_TOKENS.GO_TO_APP" | translate }}
      </app-button-fill-primary>
    }
  </div>
</div>
